import * as S from './Button.styles';
import Icon from '../icon/Icon';

const defaultProps = {
  variant: 'primary' as
    | 'primary'
    | 'secondary'
    | 'secondary-1'
    | 'tertiary'
    | 'tertiary-filled'
    | 'contained'
    | 'danger'
    | 'success',
  size: 'lg' as 'sm' | 'md' | 'lg' | 'xl' | '2xl',
  disabled: false,
  animated: false,
  iconAlign: 'none' as 'center' | 'left' | 'right' | 'none',
  type: 'button' as 'button' | 'reset' | 'submit',
  status: 'normal' as 'normal' | 'error',
};

type ButtonProps = {
  onClick?: () => void;
  children?: any;
  icon?: string;
  iconSize?: number;
  iconModifier?: 'regular' | 'strong' | 'weak' | 'inverted';
  id?: string;
  fullWidth?: boolean;
  testId?: string;
  status?: string;
  style?: any;
  title?: string;
} & typeof defaultProps;

const Button = (props: ButtonProps) => {
  const {
    id,
    size,
    variant,
    children,
    onClick,
    disabled,
    icon,
    iconSize,
    iconModifier,
    type,
    fullWidth,
    iconAlign,
    status,
  } = props;

  const renderIcon = () => {
    const iconSizes: Record<string, number> = {
      sm: 20,
      md: 24,
      lg: 20,
      xl: 20,
      '2xl': 20,
      'full-md': 20,
    };

    const iconDimension = iconSize || iconSizes[size] || 20;

    const iconVariant =
      variant === 'primary' || variant === 'contained'
        ? 'neutral'
        : variant === 'tertiary'
          ? 'info'
          : 'primary';

    return (
      <Icon
        cursor={disabled ? 'not-allowed' : 'pointer'}
        variant={iconVariant}
        modifier={iconModifier ?? 'regular'}
        name={icon!}
        width={iconDimension}
        height={iconDimension}
      />
    );
  };

  return (
    <S.Button
      data-testid={id}
      id={id}
      disabled={disabled}
      size={size}
      variant={variant}
      type={type}
      onClick={onClick}
      fullwidth={fullWidth}
      icon={icon || undefined}
      iconAlign={iconAlign}
      status={status}
      style={props.style}
      title={props.title}
    >
      {icon && (iconAlign === 'left' || iconAlign === 'center') && renderIcon()}
      {children}
      {icon && iconAlign === 'right' && renderIcon()}
    </S.Button>
  );
};

Button.defaultProps = defaultProps;

export default Button;
